import React from 'react'

export default ({ filter }) => {
  if (filter && filter.length > 2) {
    return <div>Sorry, no results for term "{filter}"</div>
  }
  return null
}
